/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Check_In_Next_InInputs */

const en_check_in_next_in = /** @type {(inputs: Check_In_Next_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Next check-in in ${i?.time}`)
};

const es_check_in_next_in = /** @type {(inputs: Check_In_Next_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Proximo registro en ${i?.time}`)
};

/**
* | output |
* | --- |
* | "Next check-in in {time}" |
*
* @param {Check_In_Next_InInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_next_in = /** @type {((inputs: Check_In_Next_InInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_Next_InInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_next_in(inputs)
	return es_check_in_next_in(inputs)
});